import { NotifyHelper } from "../../../helpers/toast";
import { eUserActionsObj } from "../../action-types/user/IUserActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const userActions = {
    ...generateActions(eUserActionsObj, "USER"),
    ...generateActionForKey(eUserActionsObj, "USER", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eUserActionsObj, "USER", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eUserActionsObj, "USER", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eUserActionsObj, "USER", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
}